// extracted by mini-css-extract-plugin
export default {"customPagination":"Pagination_customPagination__o+Dvt"};